<template>
    <article class="base-card">
        <slot />
    </article>
</template>

<script>
    export default {
        name: 'base-card',
    };
</script>

<style lang="scss" scoped>
    .base-card {
        background: secondary-palette(8);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
        border-radius: 20px;
    }
</style>
